<template>
	<v-card
		v-if="user"
		variant="flat"
	>
		<v-card-text>
			<v-form ref="user">
				<v-row>
					<v-col>
						<h3>
							<translate>
								Contact information
							</translate>
						</h3>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-text-field
							v-model="user.email"
							:label="$gettext('Email address')"
							:rules="[v => emailRegex.test(v) || $gettext('Enter an email')]"
							variant="outlined"
							color="primary"
						/>
					</v-col>
					<v-col>
						<v-text-field
							v-if="user.telephonenumbers.length > 0"
							:model-value="user.telephonenumbers[0].number"
							:label="$gettext('Phone')"
							variant="outlined"
							color="primary"
							disabled
						/>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-row>
							<v-col>
								<h3>
									<translate>
										Personal information
									</translate>
								</h3>
							</v-col>
						</v-row>
						<v-form>
							<v-row>
								<v-col>
									<v-text-field
										:label="$gettext('First Name')"
										:model-value="user.nameFirst"
										hide-details
										variant="outlined"
										color="primary"
										disabled
										aria-readonly="true"
									/>
								</v-col>
								<v-col>
									<v-text-field
										:label="$gettext('Last Name')"
										:model-value="fullLastName"
										hide-details
										variant="outlined"
										color="primary"
										disabled
										aria-readonly="true"
									/>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-select
										v-model="selectedLanguage"
										:items="languages"
										:label="$gettext('Preferred Language')"
										:disabled="updateLoading"
										item-value="iso6391"
										item-title="nativeName"
										hide-details
										color="primary"
										variant="outlined"
									/>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-checkbox
										v-model="user.newsletter"
										:label="$gettext('Newsletter')"
										:disabled="updateLoading"
										hide-details
										color="primary"
										class="mb-10"
									/>
								</v-col>
							</v-row>
						</v-form>
					</v-col>
					<v-col>
						<v-row>
							<v-col>
								<h3>
									<translate>
										Address
									</translate>
								</h3>
							</v-col>
						</v-row>
						<address-fields
							v-model="address"
							:country-name="user.domain.country.countryName"
							:user-id="$userId"
							color="primary"
						/>
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>
		<v-card-actions>
			<v-spacer />
			<v-btn
				color="primary"
				variant="flat"
				:loading="updateLoading"
				:disabled="updateLoading"
				@click="update"
			>
				<translate>
					Save
				</translate>
			</v-btn>
		</v-card-actions>
	</v-card>
	<v-skeleton-loader
		v-else
		type="paragraph, button"
	/>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';
import {
	inform,
} from 'laravel-front-library';
export default {
	name: 'ProfileEdit',
	data () {
		return {
			updateLoading: false,
			languages: [],
			address: {
				'street': '',
				'housenumber': '',
				'housenumber_suffix': '',
				'postalcode': '',
				'city': '',
				'door_code': '',
				'administrative_area': '',
				'house_name': '',
				'residential_area': '',
				'floor': '',
				'country': '',
			},
			user: null,
			selectedLanguage: null,
			emailRegex: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
		};
	},

	computed: {
		fullLastName () {
			return `${this.user.nameInfix ? `${this.user.nameInfix} ` : ''}${this.user.nameLast}`;
		}
	},

	mounted () {
		this.getUserData();
		this.getLanguageData();
	},

	methods: {
		/**
		 * Fetches the available languages
		 *
		 * @returns {void}
		 */
		getLanguageData () {
			axios.get('/api/v0/languages/supported').then(({
				data
			}) => {
				this.languages = data;
			}).catch((error) => {
				this.handleError(error);
				window.captureException(error);
			});
		},

		/**
		 * Gets the user data of currently logged in user
		 */
		getUserData () {
			axios.get(`/api/v0/users?id=${this.$userId}`).then(({
				data
			}) => {
				this.user = data[0];
				this.selectedLanguage = this.user.language.iso6391;
			}).catch(this.handleError);
		},

		/**
		 * Update language to selected
		 */
		updateLocale () {
			return new Promise((resolve, reject) => {
				axios.post('/locale', {
					'locale': this.selectedLanguage
				}).then(resolve).catch(reject);
			});
		},

		/**
		 * Submit form and update locale if necessary
		 */
		update () {
			if (this.$refs.user.validate()) {
				this.updateLoading = true;
				axios.put(`/api/v0/users/userdata?id=${this.$userId}`,
					{
						'newsletter': this.user.newsletter,
						'email': this.user.email,
						'address': this.address,
					}).then(() => {
					if (this.selectedLanguage !== this.user.language.iso6391) {
						this.updateLocale().catch((error) => {
							window.captureException(error);
						});
					} else {
						inform(this.$gettext('Updated'));
					}
					window.location.reload();
				}).catch((error) => {
					inform(error.response.data.errors[0]);
				}).finally(() => {
					this.updateLoading = false;
				});
			}
		}
	}
};
</script>
